export default "__VITE_ASSET__87d08ecb__"